import template from './seatsList.template.html';

export default {
  template,
  bindings: {
    seats: '=',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($filter, $mdMedia, listService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.list = listService;
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.seats, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.select = (data) => {
        const isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data, isSelected });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.seats && changes.seats.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
